/**
 * Admin account-merge API hook. Backed by admin-api:
 *
 *   POST /admin/users/:primaryUserId/merge
 *     body: { duplicateUserId, identityProofNote }
 *     200 → { ok, mergeRecordId, transferSummary: { matches, messages,
 *             credits, subscriptions } }
 *     400 → same_user | primary_not_found | duplicate_not_found
 *     409 → conflict + detail
 *
 * senior_moderator+ on the server. UI surfaces 4xx errors inline.
 */

import { useMutation } from '@tanstack/react-query';
import { ADMIN_API_BASE, apiFetch } from './client.js';

export interface MergeTransferSummary {
  matches: number;
  messages: number;
  credits: number;
  subscriptions: number;
}

export interface MergeResponse {
  ok: true;
  mergeRecordId: string;
  transferSummary: MergeTransferSummary;
}

export function useMergeAccountsMutation() {
  return useMutation({
    mutationFn: (args: {
      primaryUserId: string;
      duplicateUserId: string;
      identityProofNote: string;
    }) =>
      apiFetch<MergeResponse>({
        method: 'POST',
        url: `/admin/users/${encodeURIComponent(args.primaryUserId)}/merge`,
        body: {
          duplicateUserId: args.duplicateUserId,
          identityProofNote: args.identityProofNote,
        },
        baseUrl: ADMIN_API_BASE,
      }),
  });
}
